const variants = {
  primary: {
    active: {
      button: "bg-green text-white",
      icon: "white",
      loader: "bg-white",
    },
    inactive: {
      button: "",
      icon: "#4ABE82",
      loader: "bg-green-400",
    },
  },
  danger: {
    active: {
      button: "bg-orange text-white",
      icon: "white",
      loader: "bg-white",
    },
    inactive: {
      button: "",
      icon: "#FD6E5E",
      loader: "bg-orange",
    },
  },
  warning: {
    active: {
      button: "bg-yellow text-white",
      icon: "white",
      loader: "bg-white",
    },
    inactive: {
      button: "",
      icon: "#FFCC00",
      loader: "bg-yellow",
    },
  },
  secondary: {
    active: {
      button: "bg-black-700 text-white",
      icon: "white",
      loader: "bg-white",
    },
    inactive: {
      button: "",
      icon: "#313131",
      loader: "bg-black-700",
    },
  },
};

export default variants;
